import { ICreateSubjectResponseBody } from '../../interface/subjectModel';
import {
  IClassroomAssignRequest,
  IGetAllTeachers,
  IGetByIdClassroomAssignResponse,
  IGetClassroomAssignResponse,
} from '../../interface/teacherClassroomAssignModel';
import { IGetTeacherDetailsRequestParams } from '../../interface/teacherModel';
import api from '../api';
import { AxiosResponse } from 'axios';

/**
 * Create a new classroom assignment
 */
export const createClassroomAssignService = async (
  body: IClassroomAssignRequest,
): Promise<ICreateSubjectResponseBody> => {
  const response = await api.post('/teacher/assignclassroom', body);
  return response.data;
};

/**
 * Update an existing classroom assignment
 */
export const updateClassroomAssignService = async (
  classId: string,
  teacherId: string,
  body: IClassroomAssignRequest,
): Promise<ICreateSubjectResponseBody> => {
  const response = await api.put(`/teacher/assignclassroom/${classId}/${teacherId}`, body);
  return response.data;
};

/**
 * Delete a classroom assignment
 */
export const removeAssignedClassroom = async (id: string): Promise<ICreateSubjectResponseBody> => {
  const response = await api.delete(`/teacher/assignclassroom/${id}`);
  return response.data;
};

/**
 * Get all teachers list
 */
export const getAllTeachersService = async (): Promise<IGetAllTeachers> => {
  const response = await api.get('/teacher/list/all');
  return response.data;
};

/**
 * Get classroom assignments with pagination and filters
 */
export const getClassroomAssignService = async (
  params: IGetTeacherDetailsRequestParams,
): Promise<IGetClassroomAssignResponse> => {
  const response = await api.get('/teacher/assignclassroom', {
    params: { ...params, page: params.currentPage, pageSize: params.perPageRow },
  });
  return response.data;
};

/**
 * Get classroom assignment by class ID and teacher ID
 */
export const getClassroomAssignByIdService = async (
  classId: string,
  teacherId: string,
): Promise<IGetByIdClassroomAssignResponse> => {
  const response = await api.get(`/teacher/assignclassroom/${classId}/${teacherId}`);
  return response.data;
};

/**
 * Download assigned teacher report as PDF
 */
export const downloadAssignedTeacherReportService = async (): Promise<void> => {
  const response: AxiosResponse<ArrayBuffer> = await api.get('/assigned/download', {
    responseType: 'arraybuffer',
  });

  // Create an object URL from the response data (which is an ArrayBuffer)
  const fileUrl = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
  const link = document.createElement('a');
  link.href = fileUrl;
  link.download = 'assigned-teachers-report.pdf';
  link.click();
  URL.revokeObjectURL(fileUrl);
};
